import AdminApi from '../services/api';
import swal from 'sweetalert2';
import session from "../services/session";

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'costVehicle', 'vehicleId'],

    data() {
        return {
            title: '',
            buttonTitle: '',
            isLoading: false,
            selectedCost: null,
            isDisableType: true,
            hasError: '',
            name: '',
            cost: 0,
            type: 'SMALL_SERVICE',
            description: '',
        };
    },

    watch: {
        show: function(val, oldVal) {
            if (val === true) {
                if (this.costVehicle == null) {
                    this.selectedCost = null;
                    this.title = "Dodaj trošak"
                    this.buttonTitle = "Dodaj"
                    this.isDisableType = false;
                    this.reset();
                } else {
                    this.selectedCost = this.costVehicle;
                    this.title = "Izmeni trošak"
                    this.buttonTitle = "Izmeni"
                    this.isDisableType = true;
                    this.cost = this.costVehicle.cost;
                    this.name = this.costVehicle.name;
                    this.type = this.costVehicle.type;
                    this.description = this.costVehicle.description;
                }
            }
        }

    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeAddVehicleCosts')
        },
        successUpdate(){
            this.$topnavbar.$emit('successAddVehicleCosts')
        },

        successEdit(){
            this.$topnavbar.$emit('successEditVehicleCosts')
        },

        addCosts: addCosts,
        isAdmin: isAdmin,
        editCost: editCost,
        reset: reset,
    }
}

function addCosts() {
    if(this.type.length === 0 ||
        this.cost.length ===0 || this.cost === 0 ) {
        this.hasError = "Molimo popunite tip i cenu";
        return;
    }
    //
    if(this.selectedCost != null){
        this.editCost();
        return;
    }
    let _self = this;
    const newModel = {
        type: _self.type,
        name: _self.name.length === 0 ?  ' ' : _self.name,
        cost: _self.cost,
        description: _self.description,
        time: Date.now()
    };
    _self.isLoading = true;
    AdminApiService.createVehicleCost(newModel, _self.vehicleId)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })

}

function editCost() {
    let _self = this;
    const newModel = {
        type: _self.type,
        name: _self.name.length === 0 ?  ' ' : _self.name,
        cost: _self.cost,
        description: _self.description
    };
    _self.isLoading = true;
    AdminApiService.editVehicleCost(newModel,  _self.vehicleId, _self.costVehicle.id)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successEdit();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom izmene vozila."
        })
}

function reset() {
    this.name = '';
    this.cost = 0;
    this.type = 'SMALL_SERVICE';
    this.description = '';
}

function isAdmin() {
    return session.getRole() === 'ADMIN'
}



// WEBPACK FOOTER //
// ./src/modals/AddVehicleCostModal.js